<template>
    <div class="ui-page">
        <ui-page-header title="Textos Automáticos" subtitle="Textos padrão usados nas comunicações do sistema.">
            <v-btn v-if="$allowed('create')" id="btnNew" color="primary" depressed to="/textos-automaticos/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field id="name" v-model="dataList.filter.name" placeholder="Buscar pelo nome" prepend-inner-icon="mdi-magnify"
                    dense outlined hide-details class="ui-toolbar__search" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data" :server-items-length="dataList.count"
                :options.sync="dataList.options" :loading="dataList.loading" disable-sort hide-default-footer
                no-data-text="Nenhum texto foi encontrado" loading-text="Carregando dados..." class="ui-clickable-rows"
                @click:row="openIfAllowed">
                <template v-slot:[`item.name`]="{ item }">
                    <span class="ui-cell-main">{{ item.name }}</span>
                </template>

                <template v-slot:[`item.actions`]>
                    <v-icon v-if="canEdit" small class="ui-cell-chevron">mdi-chevron-right</v-icon>
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.itemsPerPage"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "DynamicTextList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                name: "",
               // client: "",
                unit: "",
               // status: ""
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    computed: {
        canEdit() {
            return this.$check('DynamicText', 'PATCH');
        },
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {
        this.load();
    },

    methods: {

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { name: "", unit: "" };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.itemsPerPage = size;
        },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/admin/dynamic-texts', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        // Abrir o texto exige permissao de edicao, como o antigo botao.
        openIfAllowed(item) {
            if (this.canEdit) this.viewItem(item);
        },

        viewItem(item) {
            this.$router.push(`textos-automaticos/${item.id}`);
        },
    },
};
</script>
